import { Link } from "react-router-dom";
import { MapPin, Clock, CalendarDays, ArrowRight } from "lucide-react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { useSettings, nextMeeting } from "../lib/settings";

export default function NextGathering({ dark = false }) {
  const { settings } = useSettings();
  const next = nextMeeting(settings);
  const dayLabel = format(next, "EEEE d MMMM", { locale: fr });

  return (
    <div
      data-testid="next-gathering-card"
      className={`rounded-2xl p-6 sm:p-7 ${
        dark
          ? "border border-white/15 bg-white/[0.07] text-cream backdrop-blur-xl"
          : "card-warm text-obsidian"
      }`}
    >
      <p className={`label-eyebrow ${dark ? "!text-terracotta-soft" : ""}`}>
        Prochaine rencontre — {settings.meeting_name}
      </p>
      <p className="mt-3 font-serif text-2xl font-semibold capitalize tracking-tight sm:text-[1.7rem]">
        {dayLabel}
      </p>
      <div className={`mt-4 space-y-2.5 text-sm ${dark ? "text-stone-300" : "text-stone-600"}`}>
        <p className="flex items-center gap-2.5">
          <Clock className="h-4 w-4 shrink-0 text-terracotta" />
          Accueil dès {settings.welcome_time} · Début à {settings.meeting_time}
        </p>
        <p className="flex items-start gap-2.5">
          <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-terracotta" />
          {settings.address}
        </p>
      </div>
      <div className="mt-6 flex flex-wrap gap-2.5">
        <a
          data-testid="next-gathering-itinerary-btn"
          href={settings.maps_url}
          target="_blank"
          rel="noreferrer"
          className={dark ? "btn-ghost-light !px-5 !py-2.5" : "btn-outline !px-5 !py-2.5"}
        >
          <MapPin className="h-4 w-4" />
          Itinéraire
        </a>
        <Link data-testid="next-gathering-visit-btn" to="/premiere-visite" className="btn-primary !px-5 !py-2.5">
          <CalendarDays className="h-4 w-4" />
          Je viens
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
